/**
 * The filter chips — app configuration, not data. Which dimension each chip
 * filters, its label and icon, and which bars show it. Options (values and
 * labels) come from the data source's bootstrap.
 */
import { Icon, type FiltersBarType } from '@deepdive-ui';
import type { ReactNode } from 'react';

import type { DimensionKey, FiltersType } from '@/data-sources/contract';

export type FilterChip = {
  id: string;
  dimension: DimensionKey;
  label: string;
  icon: ReactNode;
  /** Omitted: shown on every bar. */
  types?: FiltersBarType[];
};

/** Order and copy from Reef's `filters.fixtures.tsx`. */
export const FILTER_CHIPS: readonly FilterChip[] = [
  {
    id: 'brands',
    dimension: 'brand',
    label: 'Brands',
    icon: <Icon name="brand" />,
    types: ['competitors'],
  },
  { id: 'channels', dimension: 'channel', label: 'Channels', icon: <Icon name="channel" /> },
  { id: 'intents', dimension: 'intent', label: 'Intents', icon: <Icon name="intent" /> },
  { id: 'topics', dimension: 'topic', label: 'Topics', icon: <Icon name="topics" /> },
  {
    id: 'conversations',
    dimension: 'conversation',
    label: 'Conversations',
    icon: <Icon name="conversations" />,
  },
  {
    id: 'sentiments',
    dimension: 'sentiment',
    label: 'Sentiments',
    icon: <Icon name="sentiments" />,
  },
];

/** The dimensions a bar type renders — and therefore the only ones a page may filter by. */
export function dimensionsFor(type: FiltersType | null): DimensionKey[] {
  if (type === null) return [];
  return FILTER_CHIPS.filter((chip) => !chip.types || chip.types.includes(type)).map(
    (c) => c.dimension,
  );
}
